/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Role_AdminInputs */

const en_mk_sec_pg_role_admin = /** @type {(inputs: Mk_Sec_Pg_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const id_mk_sec_pg_role_admin = /** @type {(inputs: Mk_Sec_Pg_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Mk_Sec_Pg_Role_AdminInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_role_admin = /** @type {((inputs?: Mk_Sec_Pg_Role_AdminInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Role_AdminInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_role_admin(inputs)
	return en_mk_sec_pg_role_admin(inputs)
});